import StaticFieldText from "./StaticFieldText";

export default StaticFieldText;
